import React from 'react';
import PropTypes from 'prop-types';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { createConfirmationMessages as messages } from './DisabledTimeWindows.messages';

const CreateDisabledTimeWindowConfirm = ({ numReservations }) => (
  <Confirm
    title={<Message message={messages.title} values={{ numReservations }} />}
    acceptNode={<Message message={messages.accept} />}
    cancelNode={<Message message={messages.cancel} />}>
    <Message message={messages.body} />
  </Confirm>
);

CreateDisabledTimeWindowConfirm.propTypes = {
  numReservations: PropTypes.number,
};

export default CreateDisabledTimeWindowConfirm;
